<main class="tw:absolute tw:inset-0 tw:flex tw:w-full tw:overflow-hidden tw:bg-primary">
  <aside>
    <wzb-bo-navigation-sidebar-menu
      [items]="(grantedRoutes$ | async) ?? []"
      [activeRoute]="activeRoute()"
      [reduced]="true"
      [reducible]="false"
      (itemClicked)="handleItemClicked($event)"
    >
      <span menuLogo>
        <mat-icon class="tw:size-14!" svgIcon="menu-logo" />
      </span>

      @for (icon of icons; track trackByIcon($index, icon)) {
        <mat-icon *wzbBoNavigationSidebarMenuIcon="icon!" [svgIcon]="icon!" width="1.125em"></mat-icon>
      }

      <div menuOption>
        <hlp-select-country></hlp-select-country>
      </div>

      <wiz-sidebar [environment]="env" menuOption></wiz-sidebar>
    </wzb-bo-navigation-sidebar-menu>
  </aside>

  <div class="tw:flex tw:grow tw:flex-col">
    <div class="tw:max-w-3xl tw:p-5">
      <hlp-global-searchbar />
    </div>

    <div class="tw:grow tw:overflow-y-auto tw:bg-white tw:px-4 tw:py-6 tw:rounded-ss-3xl">
      <router-outlet></router-outlet>
    </div>
  </div>
</main>

<wzb-notifications></wzb-notifications>
